import { render } from "./UserCabinet.vue?vue&type=template&id=db817e82&scoped=true"
import script from "./UserCabinet.vue?vue&type=script&lang=js"
export * from "./UserCabinet.vue?vue&type=script&lang=js"

import "./UserCabinet.vue?vue&type=style&index=0&id=db817e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db817e82"]])

export default __exports__